import React, { Fragment } from "react"; 
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1-appd.jpg",
  heading: "Web Applications",
  description: `Our Web Application development services deliver dynamic, scalable, and secure solutions designed to meet diverse business needs. 
  From single-page applications (SPAs) to complex enterprise-grade platforms, we build web apps that are user-friendly, responsive, and future-ready. 
  Leveraging modern frameworks and cloud technologies, we ensure seamless performance, intuitive interfaces, and easy integration with your existing systems.`,

  middleImage: "/images/service/sr-d-1-2-wad.jpg",
  features: [
    "Custom Web Application Development",
    "Progressive Web Apps (PWAs)",
    "API Integration & Backend Connectivity",
    "Secure & Scalable Architecture",
    "Enterprise-Grade Web Platforms"
  ],

  challengeHeading: "Challenges in Web Applications",
  challengeParagraphs: [
    `Developing high-performance web applications requires balancing speed, security, and scalability. Handling large data sets, ensuring real-time responsiveness, and protecting against cyber threats are key challenges.`,
    `At Tech Ayukta, we tackle these complexities using modular architectures, advanced testing practices, and the latest frameworks. 
    This ensures applications that are reliable, secure, and capable of evolving with your business.`
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg"
  ],
};

const WebApplications = () => (
  <Fragment>
    <Seo
      title="Web Applications | Tech Ayukta"
      description="Tech Ayukta builds secure, scalable, and high-performance web applications including SPAs, PWAs, and enterprise-grade platforms."
      keywords="Web Applications, Web App Development, Progressive Web Apps, Enterprise Web Apps, SaaS Development, Tech Ayukta"
      canonical="https://www.techayukta.com/services/web-applications"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Web Applications"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default WebApplications;
